module.exports = __webpack_public_path__ + "img/award.c1e0fd69.svg";